import { axios } from '@Api/axiosClient';
import type { FlowStep } from '@Shared';

const baseUrl: string = 'api/RequestFlow';

export const getClientFlowApi = async (): Promise<FlowStep[]> => {

    const response = await axios.get(`${baseUrl}/LoadRequestFlow`);
    return response.data;
};
